import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Определяем начальное состояние как пустой массив строк
const initialState: string[] = [];

// Создаем slice для управления состоянием гостей
export const selectedGuestsSlice = createSlice({
  name: 'selectedGuests',
  initialState,
  reducers: {
    /**
     * Добавляем или убираем одного гостя
     * @param state - список выбранных
     * @param action - id гостя
     */
    toggleGuest: (state, action: PayloadAction<string>) => {
      const guestId = action.payload;
      const guestIndex = state.indexOf(guestId);

      // Если ID гостя уже есть в массиве, удаляем его
      if (guestIndex !== -1) {
        state.splice(guestIndex, 1);
      } else {
        // Если ID гостя отсутствует, добавляем его в массив
        state.push(guestId);
      }
    },

    /**
     * Выбираем всех гостей
     * @param state - текущий список выбранных гостей
     * @param action - список гостей
     */
    addAll: (state, action: PayloadAction<string[]>) => {
      action.payload.forEach((guestId) => {
        if (!state.includes(guestId)) {
          state.push(guestId);
        }
      });
    },
    /**
     * Очищаем список гостей
     */
    removeAll: () => initialState
  }
});

export const {
  toggleGuest,
  addAll: selectAllGuests,
  removeAll: removeAllGuests
} = selectedGuestsSlice.actions;

export default selectedGuestsSlice.reducer;
